import { enums } from "@shared/constants";
import { ShippingMethodsTypeMapIdType } from "@shared/constants/enums/enums-types";
import Tag from "@ui-kit/data-display/Tag/Tag.web";
import { useTranslation } from "@shared/utils/internationalization";
import type { ItemTypeTagSharedProps } from "./ItemTypeTag.props";

const withShippingVerbiage = (
  shippingType?: ShippingMethodsTypeMapIdType,
  itemTypeVerbiage?: string,
  willCallLabel?: string
) => {
  const { t } = useTranslation("common");
  switch (shippingType) {
    case enums.SHIPPING_METHODS.PRINT.id:
      return t("e-Ticket");
    case enums.SHIPPING_METHODS.DELIVERY.id:
      return t("Shipping");
    case enums.SHIPPING_METHODS.WILL_CALL.id:
      return willCallLabel ?? t("Will call");
    default:
      return itemTypeVerbiage;
  }
};

export default function ItemTypeTag({
  itemType,
  shippingType,
  willCallLabel,
}: ItemTypeTagProps): JSX.Element {
  const { t } = useTranslation("common");
  const getVerbiage = () => {
    switch (itemType) {
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_TICKET.id:
        return withShippingVerbiage(shippingType, t("e-Ticket"), willCallLabel);
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_MEMBERSHIP.id:
        return withShippingVerbiage(
          shippingType,
          t("Membership"),
          willCallLabel
        );
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_PRODUCT.id:
        return withShippingVerbiage(shippingType, t("Product"), willCallLabel);
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_TIP.id:
        return t("Tip");
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_USER_CREDIT.id:
        return t("Credit");
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_GIFT_CARD.id:
        return t("Gift card");
      case enums.ITEM_TYPES_MAP.ITEM_TYPE_DONATION.id:
        return t("Donation");
      default:
        return t("Other");
    }
  };

  return (
    <Tag colorPalette="primary" size="sm">
      {getVerbiage()}
    </Tag>
  );
}

export type ItemTypeTagProps = ItemTypeTagSharedProps & {
  // Add any web specific props here.
};
